export default __webpack_public_path__ + "static/media/carouselImage3_2.be6e0e08.png";